// Session partagée avec le service worker (AgDR-LOCAL-0001). Quand le navigateur
// renouvelle l'abonnement push (`pushsubscriptionchange`), public/sw-push.js doit
// envoyer le nouvel abonnement au serveur avec le jeton du lien personnel. Le
// service worker n'a pas accès à localStorage : l'appli lui écrit le jeton dans
// IndexedDB, au moment où elle envoie elle-même l'abonnement, et l'efface avec
// « Tout effacer ». Mêmes noms que SESSION dans public/sw-push.js.

export const STOCKAGE_SW = { base: 'sensa-rappel', magasin: 'service-worker', cle: 'session' };

export interface SessionSw {
  jeton: string;
  plateforme: string;
  /** Base de l'api vue par l'appli (`/api/v1` par défaut). */
  api: string;
}

function ouvrir(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const ouverture = indexedDB.open(STOCKAGE_SW.base, 1);
    ouverture.onupgradeneeded = () => ouverture.result.createObjectStore(STOCKAGE_SW.magasin);
    ouverture.onsuccess = () => resolve(ouverture.result);
    ouverture.onerror = () => reject(ouverture.error ?? new Error('indexedDB.open'));
  });
}

/** Écrit la session (ou l'efface avec null). Sans IndexedDB, ne fait rien. */
export async function ecrireSessionSw(session: SessionSw | null): Promise<void> {
  if (typeof indexedDB === 'undefined') return;
  const base = await ouvrir();
  try {
    await new Promise<void>((resolve, reject) => {
      const tx = base.transaction(STOCKAGE_SW.magasin, 'readwrite');
      const magasin = tx.objectStore(STOCKAGE_SW.magasin);
      if (session) magasin.put(session, STOCKAGE_SW.cle);
      else magasin.delete(STOCKAGE_SW.cle);
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error ?? new Error('indexedDB transaction'));
      tx.onabort = () => reject(tx.error ?? new Error('indexedDB abort'));
    });
  } finally {
    base.close();
  }
}
